import * as angular from "angular";

const importSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2FBringoz_service_point_template.xlsx?alt=media&token=3ccca77c-297d-43b5-b1a9-356516dcea84';

angular
  .module('bringoz.admin.service-points')
  .constant('servicePointsConstants', {
    importSampleFileLink: importSampleFileLink
  });

